import {
  Box,
  Button,
  Card,
  Center,
  LoadingOverlay,
  Stack,
  Text,
} from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import ProcessingStatusBadge from "../ProcessingStatusBadge";

export function ImageJobGenerateCard({ job, onRetry }) {
  const errorMessage = job?._resultFetchError;
  const isError = Boolean(errorMessage);
  // Anything sitting in jobs[] is in flight in some way: queued, processing,
  // or being finalized. The error case is the only one that isn't "waiting".
  const isWaiting = !isError;
  const mah = 400;
  const uri = job?.uri;
  // Backdrop: the job's input image when there is one, otherwise a plain
  // neutral surface — never a static placeholder photo.
  const backgroundStyle = uri
    ? {
        backgroundImage: `url(${uri})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }
    : {
        background:
          "linear-gradient(160deg, var(--mantine-color-dark-7) 0%, var(--mantine-color-dark-9) 100%)",
      };
  return (
    <Card withBorder shadow="sm" radius="md">
      <Card.Section>
        <Box
          mah={mah}
          style={{
            height: `${mah}px`,
            position: "relative",
            ...backgroundStyle,
          }}
        >
          <LoadingOverlay
            visible={isWaiting}
            zIndex={390} // 400 is the notifications, which should be on top
            overlayProps={{ blur: 4 }}
            loaderProps={{ children: <ProcessingStatusBadge job={job} /> }}
          />
          {isError && (
            <Center
              style={{
                position: "absolute",
                inset: 0,
                background: "rgba(0, 0, 0, 0.55)",
                zIndex: 390,
              }}
            >
              <Stack align="center" gap="xs" p="md">
                <IconAlertTriangle size={32} color="#ffd43b" />
                <Text size="sm" c="white" ta="center">
                  {errorMessage}
                </Text>
                <Button
                  size="xs"
                  variant="white"
                  onClick={() => onRetry?.(job.jobId)}
                  disabled={!job.jobId}
                >
                  Retry
                </Button>
              </Stack>
            </Center>
          )}
        </Box>
      </Card.Section>
    </Card>
  );
}
